import { Route } from '@angular/router';
import { WpbIndexPage } from 'app/modules/work-planning-budget/page/index/index.page';
import { WpbEditPage } from 'app/modules/work-planning-budget/page/wpb-edit/wpb-edit.component';
import { WpbCreatePage } from 'app/modules/work-planning-budget/page/wpb-create/wpb-create.page';

export const wpbDashboardRoutes: Route[] = [
    {
        path: 'work-planning-budget',
        children: [],
    },
];

export const wpbDataManagementRoutes: Route[] = [
    {
        path: 'work-planning-budget',
        children: [
            {
                path: '',
                component: WpbIndexPage,
            },
            {
                path: ':id',
                component: WpbCreatePage
            },
            {
                path: ':id/edit',
                component: WpbEditPage
            },
        ]
    },
];

export const wpbConfigurationRoutes: Route[] = [
    {
        path: 'work-planning-budget',
        children: [],
    },
];
